import { render, staticRenderFns } from "./AutorizacaoEmpresa.vue?vue&type=template&id=6a297d89&scoped=true"
import script from "./AutorizacaoEmpresa.vue?vue&type=script&lang=js"
export * from "./AutorizacaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./AutorizacaoEmpresa.vue?vue&type=style&index=0&id=6a297d89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a297d89",
  null
  
)

export default component.exports